import React from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";

type SelectTheWordProps = {
  item: {
    id: number;
    name: string;
  };
};

export const SelectTheWord: React.FC<SelectTheWordProps> = ({ item }) => {
  return (
    <ExerciseTypeContainer
      item={item as never}
      title1={item.name}
      hideVerifyButton
      exerciseNumber={item.id.toString()}
    >
      Selecione a Palavra
    </ExerciseTypeContainer>
  );
};

